import React, {useState, useEffect, useRef} from "react";
import logo from "../assets/images/logo.svg";
import mazar2 from "../assets/images/mazar2.jpg";
import candle from "../assets/images/candle.jpg";
import Footer from "./Footer";
import TopNav from "./TopNav";
import Cookies from "js-cookie";
import sia, {SOUND_DIR, WEB_URL} from "../services/Api";
import setHeaderForAxios from "../services/Api";
import LoaderView from "../tools/LoaderView";
import {Button} from "@material-ui/core";
import {notifyError, notifySuccessfulMessage} from "../App";
import {Check} from '@material-ui/icons'
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer, toast, Slide} from 'react-toastify'
import CustomDatePicker from "./modals/CustomDatePicker";
import moment from "jalali-moment";

var QRCode = require('qrcode.react');
const NewKhatm = (props) => {

    const [isLoading, setLoading] = useState(false)

    const [selectedSoundIndex, setSelectedSoundIndex] = useState(0)
    const [selectedType, setSelectedType] = useState(1);
    const [repeat, setRepeat] = useState(0);
    const [peopleCount, setPeopleCount] = useState(1);
    const [expDate, setExpDate] = useState('');
    const [description, setDescription] = useState('');
    const [prays, setPrays] = useState([]);


    const [isCodeGenerated, setIsCodeGenerated] = useState(false);
    const [link, setLink] = useState('');

    const types = [
        {label: 'قرآن', value: 1},
        {label: 'ادعیه', value: 2},
        {label: 'صلوات', value: 3},
        {label: 'جزء', value: 4},
        {label: 'سوره', value: 5},
    ]

    useEffect(() => {
        getPrays(1)
    }, []);

    const getPrays = async (type) => {
        setLoading(true)
        await sia
            .getDataFromServer("/pray?type=" + type)
            .then((res) => {
                setPrays(res.data);
                // console.log(prays)
            })
            .catch((err) => {
                console.log(err);
            });
        setLoading(false)
    }

    const [prayArray, updateprayArray] = useState([]);

    const addOrRemovePray = (prayId) => {
        var isInBefore = false
        prayArray.forEach((item, index) => {
            if (item == prayId) {
                isInBefore = true
                prayArray.splice(index, 1)
            }
        })
        if (!isInBefore) {
            prayArray.push(prayId)
        }
        updateprayArray(prayArray);
        console.log(prayArray)
    };

    useEffect(() => {
        getData()
    }, []);

    const getData = async () => {
        setLoading(true)
        await sia
            .getDataFromServer("/state")
            .then((res) => {
                setIrStates(res.data);
                // console.log(setIrStates);
            })
            .catch((err) => {
                // console.log(err);
            });
        sia
            .getDataFromServer("/city")
            .then((res) => {
                setIrCities(res.data);
            })
            .catch((err) => {
                // console.log(err);
            });
        setLoading(false)
    }

    // const [values,setValues] = useState({phone:"",password:""})
    const sendData = async (e) => {
        // setLoading(true)
        // console.log('selected sound :', selectedSoundIndex);
        // console.log('selected type :', selectedType);
        // console.log('repeat', repeat);
        // console.log('peopleCount', peopleCount);
        // console.log('expDate', expDate);
        // console.log('description', description);
        // console.log('prays', prays);

        // e.preventDefault();
        await sia
            .PostDataToServer("/funeral", {
                "type": selectedType,
                "repeat": Number(repeat),
                "personNumber": Number(peopleCount),
                "exprationTimestamp": Number(new moment(expDate, 'jYYYY/jMM/jDD').format('X')),
                "wish": description,
                "prays_id": prayArray
            })
            .then((res) => {
                if (res.status == 200) {
                    notifySuccessfulMessage('با موفقیت ثبت شد')
                    setIsCodeGenerated(true)
                    setLink('https://nekooyad.com/khatm?id=' + res.data._id)
                }
                console.log(res.data);
                // props.history.push("/profile");
            })
            .catch((err) => {
                console.log(err)
            });
        setLoading(false)
    };

    const copyLink = (e) => {
        link.select();
        document.execCommand("copy");
    }

    const [isShowingDatePicker, setIsShowingDatePicker] = useState(false)
    const [khatmDate, setKhatmDate] = useState()

    return (
        <>
            <ToastContainer rtl closeOnClick pauseOnHover position="top-center" transition={Slide}/>
            {isShowingDatePicker && <CustomDatePicker isOpen={isShowingDatePicker} onChange={(d) => {
                setExpDate(d)
                setIsShowingDatePicker(false)
            }} onClose={() => setIsShowingDatePicker(false)}/>}
            <div>
                <meta httpEquiv="content-type" content="text/html; charset=utf-8"/>
                <title>نکویاد</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
                <link rel="stylesheet" type="text/css" href="assets/css/fonts.css" media="all"/>
                <link rel="stylesheet" type="text/css" href="assets/css/styles.css" media="all"/>
                <header>
                    <div className="pagewrapper slim2" id="header-slim">
                        <div className="container">
                            <TopNav/>
                        </div>
                    </div>
                </header>
                <div className="clear"/>
                {isLoading ? <LoaderView/> : <form>
                    <div className="pagewrapper" id="khatm-details">
                        <div className="container">
                            {isCodeGenerated && <div className="pagewrapper" id="khatm-qrcode">
                                <div className="container box-sizing radius10">
                                    <div className="image radius10 box-sizing">
                                        <QRCode value={link} style={{width: '100%', height: '100%'}}/>
                                    </div>
                                    <div className="text">
                                        <p>لینک ختم : <span onClick={copyLink}>{link}</span></p>
                                        <p>به کمک لینک ختم دوره می توانید افراد مد نظر را از طریق فضای مجازی یا راه های
                                            ارتباطی دیگر مطلع نمایید جهت ارسال بر دکمه زیر کلیک کرده و که ختم دوره کپی
                                            می گردد</p>
                                        {<div style={{flexWrap: 'wrap', display: 'flex', alignItems: 'cener'}}>
                                            <a onClick={() => {
                                                notifySuccessfulMessage('کپی شد')
                                                navigator.clipboard.writeText(link)
                                            }} className="clickable copy-link radius50 ease">
                                                <img src="assets/images/copy.png" alt="" width={17} height={21}/>
                                                کپی کردن لینک
                                            </a>
                                            <a onClick={() => {
                                                window.location = './donate'
                                            }} className="clickable help-button radius50 ease">
                                                <OpenInNewIcon className="icon"/>
                                                در صورت تمایل می توانید از این کسب و کار حمایت کنید
                                            </a>
                                        </div>}
                                    </div>
                                </div>
                            </div>}
                            {!isCodeGenerated && <h2 className="main-title">جزئیات ختم</h2>}
                            {!isCodeGenerated && <div className="inputs-wrapper">
                                <select name="khatm_type" onChange={(e) => {
                                    setSelectedType(e.target.value)
                                    getPrays(Number(e.target.value))
                                }} className="input select radius10 box-sizing ease">
                                    <option value={-1}>نوع ختم</option>
                                    {types.map((item, index) => <option value={index + 1}>{item.label}</option>)}
                                </select>
                                <div className="input input-count-wrapper box-sizing radius10 ease">
                                    <input id="count-input" type="number" name="hajat" id="count_input"
                                           onChange={(e) => {
                                               setRepeat(e.target.value)
                                           }}
                                           className="hajat-input box-sizing radius10" placeholder="تعداد تکرار"/>
                                </div>

                                <div className="input input-count-wrapper box-sizing radius10 ease">
                                    <input id="count_people" type="number" name="count_people" value={peopleCount}
                                           onChange={(e) => {
                                               setPeopleCount(e.target.value)
                                           }}
                                           className="hajat-input box-sizing radius10" placeholder="تعداد نفرات دخیل"/>
                                </div>

                                <input type="text" onClick={() => setIsShowingDatePicker(true)} value={expDate}
                                       name="date" placeholder="انقضا"
                                       className="input input-datepicker khatm-date box-sizing radius10 ease"
                                       onChange={(e) => {
                                           setExpDate(e.target.value)
                                       }}/>
                            </div>}
                            {!isCodeGenerated && <div className="clear"/>}
                        </div>
                    </div>
                    {!isCodeGenerated && <div className="pagewrapper" id="khatm-hajat">
                        <div className="container">
                            <h2 className="hajat-title">حاجت از ختم</h2>
                            <input type="text" name="hajat" placeholder="مثلا شفای بیمار مربوطه" onChange={(e) => {
                                setDescription(e.target.value)
                            }}
                                   className="hajat-input box-sizing radius10"/>
                        </div>
                    </div>}
                    {!isCodeGenerated && <div className="pagewrapper" id="khatm-ghoran-player">
                        <div className="container margin-bottom0">
                            <h2 className="main-title">ختم {function () {
                                switch (Number(selectedType)) {
                                    case 1:
                                        return 'قرآن'
                                    case 2:
                                        return 'ادعیه'
                                    case 3:
                                        return 'صلوات'
                                    case 4:
                                        return 'جزء'
                                    case 5:
                                        return 'سوره'
                                }
                            }()}</h2>
                            {isLoading ? <LoaderView/> : <ul className="khatm-player-list">
                                {prays.map((item, prayIndex) => <li className="item box-sizing radius10">
                                    <h3 className="title">{item.name}</h3>
                                    <audio controls>
                                        <source
                                            src={SOUND_DIR + item.sounds[selectedSoundIndex]?.sound ?? ''}
                                            type="audio/mp3"/>
                                        Your browser does not support the audio element.
                                    </audio>
                                    <a title onClick={() => {
                                        addOrRemovePray(item._id)
                                        const newList = prays.map((item, indexx) => {
                                            if (indexx === prayIndex) {
                                                const updatedItem = {
                                                    ...item,
                                                    isChecked: item.isChecked ? !item.isChecked : true,
                                                }
                                                // console.log('updatedItem',updatedItem)

                                                return updatedItem
                                            }
                                            // console.log('item',item)
                                            return item
                                        })
                                        // console.log('newList',newList)
                                        setPrays(newList)

                                    }}
                                       className={`btn radius10 ease box-sizing clickable ${(item.isChecked ? "selected-btn" : "dislected-btn")}`}
                                       style={{position: 'relative'}}>انتخاب
                                        {item.isChecked && <Check style={{position: 'absolute', top: 8, left: 12}}/>}
                                    </a>
                                    <select name="ghaari" onChange={(e) => {
                                        setSelectedSoundIndex(e.target.value)
                                    }} className="select blue radius10 box-sizing ease">
                                        <option value={-1}>انتخاب قاری</option>
                                        {item.sounds.map((sound, index) => <option
                                            value={index}>{sound.nameGhari}</option>
                                        )}
                                    </select>
                                </li>)}
                            </ul>}
                            <div className="clear"/>
                        </div>
                    </div>}
                    {!isCodeGenerated && <div className="pagewrapper" id="khatm-submit">
                        <div className="container">
                            <input type="button" name="submit" value="ایجاد ختم" onClick={sendData}
                                   className="submit box-sizing radius10 ease"/>
                        </div>
                    </div>}
                </form>}
                <div className="clear"/>
                <Footer/>
            </div>
        </>
    );
};

export default NewKhatm;
